import React from 'react';
import PropTypes from 'prop-types';

import { Row, Form, Alert } from 'react-bootstrap';

import { isEmpty } from 'lodash';
import { ELEMENT_TYPES } from '../../../../api/AnnotationTemplates/AnnotationTemplates';

import MapContainerViewMap from '../../../containers/MapContainerViewMap';
import * as mapOps from '../../../../api/Maps/map-operations';
import * as templateOps from '../../../../api/AnnotationTemplates/annotation-template-operations';

import CenterMap from '../../CenterMap';

const TemplateImapsItemEdit = ({
  elementItem,
  baseMap,
  baseMapsZoomState,
  layersMaps,
  map,
  maps,
  mapIdSelected,
  handleZoomMap,
  handleMapSelected,
  handleUpdateLocation,
  deployEnv,
  handleLinkMap,
  externalButton,
  handleMapLoaded,
  isNotesComponent,
  linkShared,
  showErrorLink,
  leafletMap,
  handleCenterMap,
  updatedAnnotation,
  handleHeightMap,
  heightMap,
  ...rest
}) => {
  const optionList = ['Select Map', 'Link Map Shared'];

  const [optionListSelected, setOptionListSelected] = React.useState(optionList[0]);

  const handleOptionListSelected = option => {
    setOptionListSelected(option);
    if (option === optionList[0]) {
      handleLinkMap('');
    } else {
      handleMapSelected('none');
    }
  };

  React.useEffect(() => {
    if (templateOps.getElementType(elementItem) === ELEMENT_TYPES.MULTIPLEIMAPS) {
      const multiMaps = templateOps.getElementMultipleMaps(elementItem);
      if (!isEmpty(multiMaps)) {
        const firstMap = multiMaps[0];
        handleMapSelected(firstMap.mapId);
      }
    }
  }, []);

  return (
    <Form.Group style={{ padding: 0 }}>
      <Form.Group
        style={{ padding: 0 }}
        name={`${templateOps.getElementKey(elementItem)}-map`}
        className="mb-0"
      >
        <Row
          style={{ marginTop: '2%', width: '30%', paddingLeft: !isNotesComponent ? '0%' : '3%' }}
          className={!isNotesComponent ? 'd-flex justify-content-around' : 'mb-0'}
        >
          {optionList.map(option => (
            <Form.Check
              name={`${templateOps.getElementKey(elementItem)}-radio`}
              key={option}
              type="radio"
              checked={option === optionListSelected}
              onChange={() => handleOptionListSelected(option)}
              label={option}
            />
          ))}
        </Row>
        <Row
          style={{
            marginTop: '2%',
            width: '20%',
            paddingLeft: !isNotesComponent ? '0%' : '3%'
          }}
          className={
            !isNotesComponent ? 'd-flex justify-content-around' : 'd-flex justify-content-start'
          }
        >
          <Form.Label style={{ marginTop: '2%' }}>Zoom</Form.Label>
          <Form.Control
            type="number"
            style={{ width: !isNotesComponent ? '40%' : '100%' }}
            name={`${templateOps.getElementKey(elementItem)}-zoom`}
            onChange={event => handleZoomMap(event.target.value)}
            value={baseMapsZoomState}
          />
        </Row>

        {optionListSelected === 'Select Map' && (
          <>
            <Form.Label style={{ marginTop: '2%', display: 'flex', justifycontent: 'start' }}>
              Maps
            </Form.Label>
            <Form.Control
              as="select"
              name={`${templateOps.getElementKey(elementItem)}-select`}
              onChange={event => handleMapSelected(event.target.value)}
              style={{ width: '50%' }}
              value={mapIdSelected}
            >
              <option value="none">------</option>
              {maps.map(element => (
                <option key={mapOps.getId(element)} value={mapOps.getId(element)}>
                  {mapOps.getName(element)}
                </option>
              ))}
            </Form.Control>
            {!isEmpty(map) && !isEmpty(baseMap) && (
              <>
                <Form.Label style={{ marginTop: '2%', display: 'flex', justifycontent: 'start' }}>
                  Map height
                </Form.Label>
                <Form.Control
                  type="text"
                  style={{ width: '20%' }}
                  name={`${templateOps.getElementKey(elementItem)}-height`}
                  onChange={event => handleHeightMap(event.target.value)}
                  value={heightMap}
                />
                <CenterMap
                  elementItem={elementItem}
                  handleCenterMap={handleCenterMap}
                  leafletMap={leafletMap}
                  map={map}
                  maps={maps}
                  updatedAnnotation={updatedAnnotation}
                  {...rest}
                />
                <Form.Group style={{ marginTop: '2%', height: '50%' }}>
                  <MapContainerViewMap
                    baseMaps={baseMap}
                    deployEnv={deployEnv}
                    leafletMapId={`imaps-${mapIdSelected}`}
                    layers={layersMaps}
                    isPublicMap
                    map={map}
                    updateLocation={handleUpdateLocation}
                    externalBoton={externalButton}
                    handleMapLoaded={handleMapLoaded}
                    height={isNotesComponent ? '50vh' : '100vh'}
                  />
                </Form.Group>
              </>
            )}
          </>
        )}
        {optionListSelected === 'Link Map Shared' && (
          <>
            <Form.Control
              type="text"
              name={`${templateOps.getElementKey(elementItem)}-url`}
              placeholder="URL of the map"
              onChange={event => handleLinkMap(event.target.value)}
              style={{ marginTop: '2%', width: '50%' }}
            />
            {!isEmpty(linkShared) && (
              <iframe
                src={linkShared}
                width="100%"
                height="400px"
                align="center"
                title="mapShared"
              />
            )}
            {showErrorLink && (
              <Alert variant="warning">The link of map shared is not correct.</Alert>
            )}
          </>
        )}
      </Form.Group>
    </Form.Group>
  );
};
TemplateImapsItemEdit.defaultProps = {
  deployEnv: 'gmv',
  externalButton: false,
  isNotesComponent: false,
  updatedAnnotation: {}
};

TemplateImapsItemEdit.propTypes = {
  deployEnv: PropTypes.string,
  elementItem: PropTypes.object.isRequired,
  handleMapSelected: PropTypes.func.isRequired,
  handleZoomMap: PropTypes.func.isRequired,
  handleUpdateLocation: PropTypes.func.isRequired,
  baseMap: PropTypes.array.isRequired,
  layersMaps: PropTypes.array.isRequired,
  map: PropTypes.object.isRequired,
  maps: PropTypes.array.isRequired,
  mapIdSelected: PropTypes.string.isRequired,
  baseMapsZoomState: PropTypes.number.isRequired,
  handleLinkMap: PropTypes.func.isRequired,
  externalButton: PropTypes.bool,
  handleMapLoaded: PropTypes.func.isRequired,
  isNotesComponent: PropTypes.bool,
  linkShared: PropTypes.string.isRequired,
  showErrorLink: PropTypes.bool.isRequired,
  leafletMap: PropTypes.object.isRequired,
  handleCenterMap: PropTypes.func.isRequired,
  updatedAnnotation: PropTypes.object,
  handleHeightMap: PropTypes.func.isRequired,
  heightMap: PropTypes.string.isRequired
};

export default TemplateImapsItemEdit;
